import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Backward compatibility with the old '/example' prefix.
    //
    // The application used to be mounted under '/example' — a leftover of the Fuse template's
    // demo module — and every link, bookmark and email that went out before it moved still points
    // there. A prefix redirect strips the segment and carries the rest of the URL over, so
    // '/example/solicitations/1' lands on '/solicitations/1'; the query string and fragment come
    // with it, because the router only takes the *segments* from a relative redirect and keeps
    // the rest of the original URL. Matched first so those URLs never reach the tables below.
    {path: 'example', redirectTo: ''},

    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: ''},

    // The application.
    //
    // It sits at the root of the site, and it is matched *first* — ahead of the empty-path groups
    // below — because an empty-path group whose children match nothing still matches the empty URL
    // itself. Were this last, '/' would be claimed by the guest group and render an empty layout
    // behind NoAuthGuard, which is what the template's old '' → 'example' redirect existed to
    // avoid. Being first costs the groups below nothing: a path this table does not have
    // ('/sign-in', '/home') simply falls through to them.
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {path: '', loadChildren: () => import('app/modules/admin/example/example.routes')},
        ]
    },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'change-password', loadChildren: () => import('app/modules/auth/change-password/change-password.routes')},
            {path: 'security', loadChildren: () => import('app/modules/auth/security/security.routes')},
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
        ]
    }
];
